import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import messages from './messages';
import { type SwitcherItemType } from './links';

export default (homeUrl: string, isHomeRebrandEnabled: boolean): SwitcherItemType => ({
	key: 'atlassian-home',
	iconKey: isHomeRebrandEnabled ? 'atlassian-home' : 'atlassian',
	label: <FormattedMessage {...(isHomeRebrandEnabled ? messages.home : messages.atlassianHome)} />,
	href: homeUrl,
	productType: 'ATLASSIAN_HOME',
});
